import styled from 'styled-components'
import {
  calculateResponsiveSize,
  calculateMobileResponsiveSize,
  mediaMax
} from 'styles/media-queries'

export const SliderWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  position: relative;
`
export const SliderItem = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  grid-area: 1/1;
  transition: opacity 2s;
  &.entering,
  &.entered {
    opacity: 1;
  }
  &.exiting,
  &.exited {
    opacity: 0;
  }
  ${mediaMax('mobile')} {
  }
`
export const Section = styled.section`
  height: 100%;
  ${mediaMax('mobile')} {
  }
`
export const Pagination = styled.div`
  display: flex;
  position: absolute;
  bottom: ${calculateResponsiveSize(30)};
  justify-content: center;
  width: 100%;
  gap: ${calculateResponsiveSize(18)};
  &.left {
    bottom: ${calculateResponsiveSize(50)};
    left: ${calculateResponsiveSize(50)};
    justify-content: flex-start;
  }
  ${mediaMax('mobile')} {
    bottom: ${calculateMobileResponsiveSize(30)};
    gap: ${calculateMobileResponsiveSize(18)};
    &.left {
      bottom: ${calculateMobileResponsiveSize(30)};
      left: auto;
      justify-content: center;
    }
  }
`

export const PaginationItem = styled.div`
  background: #fff;
  width: ${calculateResponsiveSize(6)};
  height: ${calculateResponsiveSize(6)};
  opacity: 0.75;
  border-radius: ${calculateResponsiveSize(2.25)};
  transition: opacity 2s;
  position: relative;

  ${({ $active }) => ($active ? 'opacity: 1;' : '')}

  & .loader {
    position: absolute;
    left: ${calculateResponsiveSize(-9)};
    top: ${calculateResponsiveSize(-9)};
  }
  ${mediaMax('mobile')} {
    width: ${calculateMobileResponsiveSize(6)};
    height: ${calculateMobileResponsiveSize(6)};
    border-radius: ${calculateMobileResponsiveSize(2.25)};
    & .loader {
      left: ${calculateMobileResponsiveSize(-9)};
      top: ${calculateMobileResponsiveSize(-9)};
    }
  }
`
